import { Component } from 'react';
import {
  ContentTypeEnum,
  fontColorEnum,
  BackgroundColorEnum,
} from '../../constants/cms-constants';
import BannerComponent from '../../components/BannerComponent';
import { BlockInstanceProps } from '../Block';
import {
  ComponentWithControlOptions,
  ControlOption,
} from '../../utils/controlOptions/ControlOptionDecorator';
import controlOptionDefinitions from '../../utils/controlOptions/controlOptionDefinitions';

@ControlOption([
  {
    key: 'backgroundColor',
    definition: controlOptionDefinitions.backgroundColor,
  },
  {
    key: 'fontColor',
    definition: controlOptionDefinitions.fontColor,
  },
])
class BannerBlock extends ComponentWithControlOptions<BlockInstanceProps> {
  render() {
    const { block, blockContent } = this.props;
    const controlOptions = block?.controlOptionsV2;
    const backgroundColor =
      BackgroundColorEnum[controlOptions?.backgroundColor];
    const fontColor = fontColorEnum[controlOptions?.fontColor];

    let mediaItems;
    blockContent.doQuery((content) => {
      mediaItems = content.getAllOfType(ContentTypeEnum.MEDIAITEM, true);
    });

    return (
      <BannerComponent
        mediaItems={mediaItems}
        backgroundColor={backgroundColor}
        fontColor={fontColor}
      />
    );
  }
}

export default BannerBlock;
